'use client';

// This file is only needed as long as ui-components-web doesn't publish files with the 'use client' React directive
// This type of barrel file is not ideal for performance, so this should be removed once the issue is resolved
export { Button } from '@curology/ui-components-web/react/Button';
export { Typography } from '@curology/ui-components-web/react/Typography';
export { SelectInput } from '@curology/ui-components-web/react/SelectInput';
export { SelectOption } from '@curology/ui-components-web/react/SelectInput/SelectOption';
export { Highlight } from '@curology/ui-components-web/react/Highlight';
export { Link } from '@curology/ui-components-web/react/Link';
